import { adminPeopleOpsReadOnly, type AdminProfile } from "./AdminScopeContext";

/** Employee-domain write gate. Area managers may maintain assigned-store records. */
export function adminCanManageEmployeeRecords(
  profile: AdminProfile | null,
): boolean {
  if (profile?.isSuperAdmin) {
    return true;
  }
  return (
    profile?.role === "store_manager" ||
    profile?.role === "area_manager" ||
    profile?.role === "owner" ||
    profile?.role === "finance"
  );
}

/** Employee record sections follow the same management capability. */
export function adminCanUseEmployeeRecords(
  profile: AdminProfile | null,
): boolean {
  return adminCanManageEmployeeRecords(profile);
}

/**
 * Binding-token issuance still requires a WeChat-bound operating identity.
 * Finance may maintain employee records from Admin, but must not see a button
 * whose backend contract cannot be completed by that storeless HQ actor.
 */
export function adminCanGenerateEmployeeBinding(
  profile: AdminProfile | null,
): boolean {
  return adminCanManageEmployeeRecords(profile) && profile?.role !== "finance";
}

/** Mirrors the existing employee binding DELETE endpoint role set. */
export function adminCanUnbindEmployee(profile: AdminProfile | null): boolean {
  return adminCanManageEmployeeRecords(profile);
}

/** Menu-level marker derived from the same role capabilities used by pages. */
export function adminPeopleOpsMenuItemReadOnly(
  profile: AdminProfile | null,
  itemKey: string,
): boolean {
  if (!adminPeopleOpsReadOnly(profile)) {
    return false;
  }
  return itemKey !== "/employees" || !adminCanManageEmployeeRecords(profile);
}
